var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.loading)?_c('loading'):_vm._e(),_c('header-component'),_c('router-view'),_c('footer-component')],1)}
var staticRenderFns = []

export { render, staticRenderFns }